import React from 'react';
import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import ImageCompressor from 'compressorjs';
import PropTypes from 'prop-types';
import WebcamCaptureNew from '../webcam/WebcamCaptureNew';
import { getMimetype } from '../../utils/validation/index';
import { ModalFactory } from '../../components/modal/modal';
import { IN_POA_FRONT_DOCS } from '../../utils/constants';
import { ATTEST_ICON, CLOSE, UPLOAD_FILE_ICON } from '@Images';

class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFileInput: true,
      showPopup: false,
      domEle: [],
      showCapturePoaCase: false
    };
  }

  componentDidMount() {
    if (this.props.countryCode === 'IN') this.setState({ showFileInput: false });
  }

  onChange = (e) => {
    this.setState({ showPopup: false });
    const {
      input: { onChange },
      onChangeFile,
      fileSizeCheckInMB
    } = this.props;

    let target = e.target;
    if (e.target && e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const fileSize = file.size;
      const fileSizeInMB = fileSize / 1000 / 1000;
      const fileType = file.type;
      const filereader = new FileReader();
      let validateFor = this.props.validateFor;

      filereader.onloadend = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(evt.target.result);
          let bytes = [];
          uint.forEach((byte) => {
            bytes.push(byte.toString(16));
          });
          const hex = bytes.join('').toUpperCase();
          let binaryFileType = getMimetype(hex);
          let isInvalidSize = fileSizeCheckInMB(file.size, 5);
          let isInvalidExtension = !validateFor.includes(binaryFileType);

          // Process the file after validation
          if (file && fileSize) {
            // Compress uploaded image
            if (
              fileType !== 'application/pdf' &&
              fileSizeInMB > 1 &&
              fileSizeInMB <= 5 &&
              !isInvalidSize &&
              !isInvalidExtension
            ) {
              // Apply compression for images between 1-5 MB
              new ImageCompressor(file, {
                quality: 0.8,
                convertSize: 1000000, // Convert PNG files > 1MB to JPEG
                success: (result) => {
                  // Handle the compressed image file
                  result.binaryFileType = binaryFileType;
                  onChange(result);
                  onChangeFile({ target, dataURL: evt.target.result });
                },
                error: (err) => {}
              });
            } else {
              // No compression needed
              file.binaryFileType = binaryFileType;
              onChange(file);
              onChangeFile({
                target,
                isInvalid: isInvalidExtension || isInvalidSize,
                dataURL: evt.target.result
              });
            }
          }
        }
      };

      // Read first 4 bytes for file type validation
      const blob = file.slice(0, 4);
      filereader.readAsArrayBuffer(blob);
    }
  };

  openFile = (showUploadBtn, id, onClose) => {
    this.setState({ showFileInput: true });
    let input = document.createElement('input');
    input.type = 'file';
    input.onchange = this.onChange;
    input.id = id;
    input.hidden = !showUploadBtn;
    input.onBlur = this.blur;
    this.setState({ showPopup: true, domEle: [input] });
    onClose(false);
  };

  openCamera = (onClose) => {
    this.setState({ showCapturePoaCase: true });
    onClose(false);
  };
  //This pop up comes only in case of INDIA POA uploads
  showSampleModal = async (type, showUploadBtn, id) => {
    return await ModalFactory.builder(
      (onClose) => (
        <div className="attest-modal">
          <div className="contentWrapper">
            <div className="content">
              <div className="close" onClick={() => onClose(false)}>
                <img src={CLOSE} alt="close" width="13px" height="13px" />
              </div>
              <p className="text1">Is this doument self-attested?</p>
              <div>
                <img src={ATTEST_ICON} alt="attest" width="70px" height="70px" />
              </div>
              <div className="text2">
                Please confirm that the uploaded address proof is self-attested and clearly
                readable.
              </div>
              <div className="buttons">
                <button
                  className="check-again"
                  onClick={() =>
                    type === 'camera'
                      ? this.openCamera(onClose)
                      : this.openFile(showUploadBtn, id, onClose)
                  }
                >
                  <p>Yes, I confirm</p>
                </button>
                <p
                  className="confirm"
                  onClick={() => {
                    this.setState({ showPopup: false });
                    onClose(false);
                  }}
                >
                  No, check again
                </p>
              </div>
            </div>
          </div>
        </div>
      ),
      'self-attest-modal',
      true
    );
  };

  showCapture = () => {
    this.webcamCapture.showCapture();
  };

  blur = () => {
    this.props.input.onBlur(this.props.input.value);
  };

  render() {
    const {
      meta: { touched, error },
      input,
      disabled,
      fileUploadName,
      onChangeFile,
      countryCode,
      showUploadBtn,
      isTakeAPicture,
      toggleFeature,
      label = 'Upload scanned file',
      camLabel,
      showCaptureBtn
    } = this.props;
    let visibility =
      countryCode === 'IN' &&
      !toggleFeature &&
      !this.state.showFileInput &&
      IN_POA_FRONT_DOCS.includes(fileUploadName)
        ? true
        : false;
    return (
      <div className={'file-input'}>
        <div className={toggleFeature ? 'updc-upload-button-container' : ''}>
          <div
            className={`btn-doc-upload ${!showUploadBtn ? 'hidden' : ''}`}
            style={toggleFeature ? { border: 'none', margin: 0, padding: 0 } : {}}
            onClick={() => {
              if (!this.state.showPopup && visibility) {
                this.showSampleModal(
                  'document',
                  showUploadBtn,
                  this.props.id
                    ? this.props.id.replace(/[._]/g, '-').toLowerCase()
                    : input.name.replace(/[._]/g, '-').toLowerCase()
                );
              }
            }}
          >
            {showUploadBtn &&
              !toggleFeature && [
                <Image key={'icon'} src={UPLOAD_FILE_ICON} className="icon" />,
                <a
                  href="/#"
                  key={'upload-file'}
                  id={fileUploadName.replace(/[._]/g, '-').toLowerCase() + '-upload-file'}
                >
                  {label}
                </a>
              ]}

            {showUploadBtn && toggleFeature && (
              <div className="updc-upload-button-container">
                <div className="updc-upload-button">
                  <img
                    className="icon"
                    src={this.props.uploadImage || UPLOAD_FILE_ICON}
                    alt="file-upload"
                  />
                  <div className="icon-text">{this.props.label || 'Upload'}</div>
                </div>
              </div>
            )}

            {/* Pop up condition for india poa case */}
            {!this.state.showPopup && visibility && <div className="overide-input"></div>}
            {this.state.showPopup && this.state.domEle[0].click()}

            {!visibility && (
              <input
                type={this.props.type}
                id={
                  this.props.id
                    ? this.props.id.replace(/[._]/g, '-').toLowerCase()
                    : input.name.replace(/[._]/g, '-').toLowerCase()
                }
                accept={this.props.acceptedFormats}
                onChange={this.onChange}
                onBlur={this.blur}
                hidden={!showUploadBtn}
                disabled={disabled}
              />
            )}
          </div>
          {showUploadBtn && showCaptureBtn && (
            <span className={`${toggleFeature ? 'link-separator-new' : 'link-separator'}`}>
              {toggleFeature ? 'or' : 'Or'}
            </span>
          )}
          {showCaptureBtn && (
            <WebcamCaptureNew
              {...this.props}
              onRef={(ref) => (this.webcamCapture = ref)}
              fileUploadName={fileUploadName}
              onChangeFile={(webcamData) => onChangeFile({ webcamData })}
              countryCode={countryCode}
              currentScreen={this.props.currentScreen}
              accountType={this.props.accountType}
              isTakeAPicture={isTakeAPicture}
              toggleFeature={toggleFeature}
              camLabel={camLabel}
              poaCameraVisibility={
                countryCode === 'IN' && !toggleFeature && IN_POA_FRONT_DOCS.includes(fileUploadName)
                  ? true
                  : false
              }
              showSampleModal={this.showSampleModal}
              showCapturePoaCase={this.state.showCapturePoaCase}
            />
          )}
        </div>

        {/* error validations specifically for india on first render after input calling */}
        <div className="link-err">
          {countryCode === 'IN' &&
            IN_POA_FRONT_DOCS.includes(fileUploadName) &&
            this.state.showFileInput &&
            !touched &&
            error && <span className="file-input-error">{error}</span>}
        </div>

        <div className="link-err">
          {touched && error && <span className="file-input-error">{error}</span>}
        </div>
        {countryCode === 'IN' && fileUploadName.substring(0, 14) === 'INDIVIDUAL_POA' && (
          <div className="self-attesst-text">Ensure document is self attested.</div>
        )}
      </div>
    );
  }
}

FileInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  onChangeFile: PropTypes.func,
  fileInfo: PropTypes.any,
  type: PropTypes.any,
  id: PropTypes.string,
  fileSizeCheckInMB: PropTypes.func,
  validateFor: PropTypes.array,
  disabled: PropTypes.bool,
  fileUploadName: PropTypes.string,
  countryCode: PropTypes.string,
  showUploadBtn: PropTypes.bool,
  currentScreen: PropTypes.string,
  accountType: PropTypes.string,
  isTakeAPicture: PropTypes.bool,
  label: PropTypes.string,
  camLabel: PropTypes.string,
  toggleFeature: PropTypes.any,
  showCaptureBtn: PropTypes.bool,
  uploadImage: PropTypes.string,
  acceptedFormats: PropTypes.array
};

export default FileInput;
